/* unplugin-vue-components disabled */import script from "./CSGItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CSGItem.vue?vue&type=script&setup=true&lang=js"

import "./CSGItem.vue?vue&type=style&index=0&id=43da43ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43da43ea"]])

export default __exports__